import React from 'react';
import { connect } from 'react-redux';

import {
  getEventList,
  getEventListCount,
  getEventListError,
  getEventListFetched,
  getEventListFetching,
  getEventListTotal,
} from '../../state/reducers';

import EventSearch from '../../components/EventSearchName/EventSearch';

const EventSearchNameInnerContainer = props => (
  <EventSearch
    {...props}
  />
);

// Selectors are used so state shape is encapsulated within reducers
const mapStateToProps = (state, { query }) => ({
  count: getEventListCount(state, query),
  fetched: getEventListFetched(state, query),
  fetching: getEventListFetching(state, query),
  error: getEventListError(state, query),
  events: getEventList(state, query),
  total: getEventListTotal(state, query),
});

// Wrap in [react-redux connect](https://github.com/reactjs/react-redux/blob/master/docs/api.md#connect)
const EventSearchNameInnerContainerWithRedux = connect(mapStateToProps)(EventSearchNameInnerContainer);  // eslint-disable-line no-class-assign, max-len

export default EventSearchNameInnerContainerWithRedux;



// WEBPACK FOOTER //
// ./app/src/containers/EventSearchName/inner.jsx